import React from 'react';
import { Box } from '@mui/material';
import { ActionCancelButtonsArea } from '../action-cancel-buttons-area';
import { Lx } from '../../../i18n/consts';

interface Props {
    onCancel: () => void;
    onConfirm: () => void;
    children: React.ReactNode;
    actionLocalizationId?: string;
    cancelLocalizationId?: string;
}

export default function MobileFilter({ 
    onCancel,
    onConfirm,
    children,
    actionLocalizationId,
    cancelLocalizationId,
}: Props) {
    return (
        <>
            <Box style={{width: '100%'}}>
                {children}
            </Box>
            <Box style={{position: 'fixed', zIndex: 1000, bottom: 0, left: 0, right: 0, padding: '12px' }}>
                <ActionCancelButtonsArea
                    idActionLocalization={actionLocalizationId ?? Lx.General.APPLY}
                    idCancelLocalization={cancelLocalizationId}
                    onCancel={onCancel}
                    onAction={onConfirm}
                />
            </Box>
        </>
    );
}
